export const acceptInviteTranslations = {
  lv: {
    title: 'Pievienoties organizācijai',
    description:
      'Jums ir nosūtīts uzaicinājums pievienoties edy365. Izveidojiet kontu, lai to pieņemtu.',
    checking: 'Pārbauda uzaicinājumu…',
    invitation: 'Loma: {{role}} · derīgs līdz {{validTill}}',
    phone: 'Tālrunis (nav obligāts)',
    termsRequired: 'Lai izveidotu kontu, jāpiekrīt lietošanas noteikumiem',
    accept: 'Pieņemt uzaicinājumu',
    acceptErrorTitle: 'Neizdevās pieņemt uzaicinājumu',
    acceptError: 'Mēģiniet vēlreiz.',
    invalidTitle: 'Uzaicinājums nav derīgs',
    invalid:
      'Šī uzaicinājuma saite ir nederīga vai beigusies. Lūdziet organizācijas administratoram nosūtīt jaunu uzaicinājumu.',
    successTitle: 'Konts izveidots',
    successText: 'Konts ir izveidots un pievienots organizācijai {{organization}}.',
    roleGranted: 'Jūsu loma: {{role}}',
    noSeat:
      'Organizācijai pašlaik nav brīvu vietu, tāpēc jūs pievienojāties bez lomas. Sazinieties ar organizācijas administratoru.',
    continue: 'Turpināt',
    roles: {
      None: 'Bez lomas',
      User: 'Lietotājs',
      Manager: 'Pārvaldnieks',
      Admin: 'Administrators',
      Intern: 'Praktikants',
    },
  },
  en: {
    title: 'Join the organization',
    description:
      'You have been invited to join edy365. Create your account to accept the invitation.',
    checking: 'Checking the invitation…',
    invitation: 'Role: {{role}} · valid until {{validTill}}',
    phone: 'Phone (optional)',
    termsRequired: 'Agree to the terms of use to create your account',
    accept: 'Accept invitation',
    acceptErrorTitle: 'Unable to accept the invitation',
    acceptError: 'Please try again.',
    invalidTitle: 'Invitation is not valid',
    invalid:
      'This invitation link is invalid or has expired. Ask the organization administrator to send a new invitation.',
    successTitle: 'Account created',
    successText: 'Your account has been created and has joined {{organization}}.',
    roleGranted: 'Your role: {{role}}',
    noSeat:
      'The organization has no free seat right now, so you joined without a role. Contact the organization administrator.',
    continue: 'Continue',
    roles: {
      None: 'No role',
      User: 'User',
      Manager: 'Manager',
      Admin: 'Administrator',
      Intern: 'Intern',
    },
  },
} as const
